module.exports = __webpack_public_path__ + "static/media/VaskupienSite.d575b42a.mp4";